import classes from "./RouteConnector.module.scss";

const RouteConnector = () => {
    return (
        <div className={classes.connectorContainer}>
            <div className={classes.startCircle}></div>
            <div className={classes.line}></div>
            <div className={classes.pin}></div>
        </div>
    );
};

export default RouteConnector;
